import Actions from './components/actions';
// import AOS from 'aos';
import 'aos/dist/aos.css';
import Sliders from './components/sliders';
// import myParallax from './components/parallax';
import Cf7 from './components/cf7';

new Actions().init();
new Sliders().init();
new Cf7().init();
// new myParallax().init();

// AOS.init({
//     duration: 2000,
//     once: true,
// });
